import { Link } from '@remix-run/react'
import { clsx } from 'clsx'
import { type ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

type EmptyStateProps = {
  className?: string
  heading?: string | number
  headingClassName?: string
  title: string
  titleClassName?: string
  message?: string | ReactNode
  messageClassName?: string
  cta?: ReactNode | boolean
}

export function ErrorView({
  className,
  heading = 'Oops!',
  headingClassName,
  title,
  titleClassName,
  message,
  messageClassName,
  cta = false,
}: EmptyStateProps) {
  return (
    <>
      <div
        className={twMerge(
          'grid min-h-screen grid-cols-1 grid-rows-[1fr,auto,1fr] p-6 lg:grid-cols-[max(50%,36rem),1fr]',
          className,
        )}
      >
        <main className="mx-auto w-full max-w-7xl px-6 py-24 sm:py-32 lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:px-8">
          <div className="max-w-lg">
            <p
              className={twMerge(
                'text-xl font-semibold leading-8',
                clsx(typeof heading == 'number' ? 'text-error' : 'text-primary'),
                headingClassName,
              )}
            >
              {heading}
            </p>
            <h1
              className={twMerge(
                'mt-4 text-3xl font-bold tracking-tight sm:text-5xl',
                titleClassName,
              )}
            >
              {title}
            </h1>
            <div className={twMerge('mt-6 leading-7 text-neutral-content', messageClassName)}>
              {message}
            </div>
            <div className="mt-10 inline-flex items-center justify-center gap-4">
              <Link to="/" className="text-sm font-semibold leading-7 text-accent">
                <span aria-hidden="true">&larr;</span> Back to home
              </Link>
              {cta && cta}
            </div>
          </div>
        </main>
        <div className="hidden lg:relative lg:col-start-2 lg:row-start-1 lg:row-end-4 lg:block">
          <img
            src="/assets/maintenance.svg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
          />
        </div>
      </div>
    </>
  )
}
